import { CSVLink } from "react-csv";
import Select from "react-select";
import { useProductList } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const ProductList = () => {
  const { t } = useLocale();
  const Input = useElement("Input");
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Table = useComponent("Table");
  const TrashConfirmModal = useComponent("TrashConfirmModal");
  const exportedFileName =
    "exported_product_" +
    new Date().getDate() +
    "_" +
    new Date().getMonth() +
    "_" +
    new Date().getFullYear() +
    ".csv";
  const {
    trackScrolling,
    trashAction,
    filteredList,
    exportedData,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    activeFilter,
    setactiveFilter,
    filterItems,
    tableData,
    search,
    searchKey,
    resetSearch,
    tableContent,
    isMultipleDelete,
    deleteChecked,
    deleteSelectProduct,
    trashCancel,
    activeShownTotal,
    showTrashConfirm,
    filterTags,
  } = useProductList();

  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="flex title mb50">
        {t(trashAction ? "trashed" : "all")} Products
        {!trashAction && (
          <>
            <Link
              className="btn btn-primary btn-small ml20"
              href="/admin/product/add"
            >
              {t("add")}
            </Link>
            <Link
              className="btn btn-primary btn-small ml20"
              href="/admin/import/product"
            >
              Import
            </Link>
            {filteredList.length !== 0 && (
              <span className="btn btn-primary btn-small ml20 export-btn">
                <CSVLink
                  data={exportedData}
                  filename={exportedFileName}
                  className="export-btn"
                  target="_blank"
                >
                  {t("export")}
                </CSVLink>
              </span>
            )}
            {(checkedList.length !== 0 || checkedAll) && (
              <Button
                onClick={() => {
                  setisMultipleDelete(true);
                  setshowTrashConfirm(true);
                }}
                className="btn btn-outline btn-small"
              >
                {t("delete")}
              </Button>
            )}
          </>
        )}
      </h1>
      <div className="filter-box">
        <div className="filters relative">
          <label className="filter-label-add">{t("status")}: </label>
          <Select
            value={activeFilter}
            defaultValue={activeFilter}
            onChange={(e, i) => {
              setactiveFilter(e);
              filterItems(e.value, i, tableData);
            }}
            options={filterTags}
          />
        </div>
        <div className="search-box">
          <Input
            name="searchKey"
            value={searchKey || ""}
            placeholder={t("placeholder.search")}
            onChange={search}
          />
          <i className="hi-close" onClick={resetSearch}></i>
        </div>
      </div>
      <Table data={tableContent} pageSize={activeShownTotal} />
      <TrashConfirmModal
        trashOkAction={() => {
          isMultipleDelete ? deleteChecked() : deleteSelectProduct();
        }}
        trashCancelAction={trashCancel}
        showTrashConfirm={showTrashConfirm}
        isMultipleDelete={isMultipleDelete}
      />
    </div>
  );
};
